import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
const reader = new FileReader();

@Pipe({
  name: 'imgWallOfTrophies'
})
export class ImgWallOfTrophiesPipe implements PipeTransform {

  constructor(
    private http: HttpClient,
  ) { }

  transform(url: string) {

    return new Observable<string>((observer) => {

      if (url) {
        this.http.get<string>(url).subscribe(response => {
          observer.next(response);
        });

      }
      return { unsubscribe() { } };
    });
  }

}
